import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';

type VerdictVariants = 'small' | 'extrasmall' | 'big' | 'plugin';

export type PrototypeVerdictProps = {
  success: boolean;
  variant: VerdictVariants;
};

const weightByVariant = {
  plugin: 200,
  big: 500,
  small: 700,
  extrasmall: 700,
};

const sizeByVariant = {
  plugin: 85,
  big: 85,
  small: 24,
  extrasmall: 18,
};

const Verdict = styled('span')<{ success: boolean; variant: VerdictVariants }>(
  ({ success, variant }) => ({
    fontSize: sizeByVariant[variant],
    fontWeight: weightByVariant[variant],
    textTransform: 'uppercase',
    color: success ? '#4BC840' : 'var(--error-error-icon-primary-color)',
  })
);

export const PrototypeVerdict = ({
  success,
  variant,
}: PrototypeVerdictProps) => {
  const { t } = useI18n();
  const verdict = success
    ? t('prototypes:report.decision.go')
    : t('prototypes:report.decision.no_go');

  return (
    <Verdict success={success} variant={variant}>
      {verdict}
    </Verdict>
  );
};
